<!-- Chat message bubble showing a loading indicator while the agent is busy. -->

<script lang="ts" setup>
import Loader from '../Loader.vue';
import ChatAgentAvatar from './ChatAgentAvatar.vue';
import ChatMessage from './ChatMessage.vue';
</script>

<template>
  <ChatMessage color="white">
    <template #avatar>
      <ChatAgentAvatar />
    </template>

    <template #content>
      <Loader :class="css.loader" />
    </template>
  </ChatMessage>
</template>

<style lang="scss" module="css">
.loader {
  width: 24px;
  height: 24px;
  color: $color-doctor-600;
}
</style>
